// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"25efe121","453":"258b012d","517":"a8357971","948":"7d11a89d","995":"27f72832"}[chunkId] + ".chunk.js";
};